import {
  Popover,
  PopoverBackdrop,
  PopoverBody,
  PopoverContent,
  Pressable,
  PopoverArrow,
} from "@gluestack-ui/themed";
import React from "react";
import { TooltipProps } from "@components/atoms/Tooltip/types";

const Tooltip = ({
  isOpen,
  setIsOpen,
  trigger,
  children,
  tooltipBackgroundColor,
  showOnPress,
  onTriggerPress,
  onClose,
  popoverProps,
  popoverContentProps,
  popoverBodyProps,
  disableTriggerShowEffect,
  showArrowIcon = true,
  useRNModal = false,
  supportedOrientations,
  alignment = "center",
  placement = "bottom",
}: TooltipProps) => {
  const triggerNode = typeof trigger === "function" ? trigger() : trigger;
  const openTooltip = () => {
    setIsOpen(true);
  };
  const closeTooltip = () => {
    onClose?.();
    if (isOpen) {
      setIsOpen(false);
    }
  };

  return (
    <Popover
      useRNModal={useRNModal}
      onClose={closeTooltip}
      onOpen={openTooltip}
      placement={placement}
      shouldFlip={true}
      isOpen={isOpen}
      size="md"
      trigger={(triggerProps) => {
        return (
          <Pressable
            {...triggerProps}
            onPress={(event) => {
              if (showOnPress && !disableTriggerShowEffect) {
                onTriggerPress?.();
                openTooltip();
              } else {
                triggerProps?.onPress?.(event);
              }
            }}
            onHoverIn={() => {
              if (!showOnPress && !disableTriggerShowEffect) {
                openTooltip();
              }
            }}
          >
            {triggerNode}
          </Pressable>
        );
      }}
      {...popoverProps}
      {...(supportedOrientations && { supportedOrientations })}
    >
      <PopoverBackdrop backgroundColor={"transparent"} />
      <PopoverContent
        backgroundColor={tooltipBackgroundColor}
        width={popoverProps?.size ? undefined : 175}
        alignItems={alignment}
        {...popoverContentProps}
      >
        {showArrowIcon && (
          <PopoverArrow backgroundColor={tooltipBackgroundColor} />
        )}
        <PopoverBody {...popoverBodyProps}>{children}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default Tooltip;
